export const selectLessons = (state) => state.lessons.all || [];
export const selectCurrentLesson = (state) => state.lessons?.current || null;
export const selectIsLoading = (state) => state.lessons.isLoading;
export const selectLastLesson = (state) => state.lessons.last || null;
export const selectLessonsCount = (state) => state.lessons.count || 0;
